<base-detail-page  [config]="baseDetailPageConfig" (onLoadedDetail)="onLoadedDetail($event)"/>